import { create } from 'zustand';

type SidebarStore = {
  collapsed: boolean;
  toggle: () => void;
  setCollapsed: (collapsed: boolean) => void;
};

export const useSidebarStore = create<SidebarStore>()((set) => ({
  collapsed: typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  toggle: () => set((s) => ({ collapsed: !s.collapsed })),
  setCollapsed: (collapsed) => set({ collapsed }),
}));
